import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=f81f1b1a&scoped=true"
import script from "./checkDetail.vue?vue&type=script&lang=js"
export * from "./checkDetail.vue?vue&type=script&lang=js"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=f81f1b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81f1b1a",
  null
  
)

export default component.exports